import React from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { FiExternalLink } from "react-icons/fi";
import { BsGithub } from "react-icons/bs";
import { AiOutlineLink } from "react-icons/ai";
import { Link } from "react-router-dom";

import Technologies from "../../components/portfolio/Technologies";
import FullCarousel from "../../components/portfolio/FullCarousel";
import Demo from "../../components/portfolio/Demo";

import img1 from "../../assets/images/portfolio/discord-feud/pic7.png";
import img2 from "../../assets/images/portfolio/discord-feud/pic8.png";
import img3 from "../../assets/images/portfolio/discord-feud/pic9.png";
import img4 from "../../assets/images/portfolio/discord-feud/pic1.png";
import img5 from "../../assets/images/portfolio/discord-feud/pic2.png";
import img6 from "../../assets/images/portfolio/discord-feud/pic3.png";
import img7 from "../../assets/images/portfolio/discord-feud/pic4.png";
import img8 from "../../assets/images/portfolio/discord-feud/pic5.png";
import img9 from "../../assets/images/portfolio/discord-feud/pic6.png";

import demo1 from "../../assets/images/portfolio/discord-feud/demo1.m4v";

function DiscordFeud() {
  const technologies = ["Javascript", "Discord JS", "ReactJS"];

  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

  const demos = [demo1];
  return (
    <div className="bg-slate-50 min-h-screen relative flex flex-col items-center">
      <div className="h-20 bg-cool-300 absolute top-0 w-full"></div>

      <div className="relative w-[90%] bg-white z-50 py-40 md:px-10 px-5 drop-shadow-md flex flex-col items-center mt-10 overflow-y-scroll h-[calc(100vh-4rem)]">
        <Link
          to="/portfolio"
          className="bg-cool-300 absolute top-10 left-10 text-white rounded-full w-20 h-20 flex items-center justify-center drop-shadow-md"
        >
          <IoArrowBackOutline size={50} />
        </Link>

        <div className="">
          <h1 className="text-cool-400 font-semibold text-4xl">Discord Feud</h1>
        </div>

        <div className="w-[80%] mt-10 drop-shadow-md">
          <h2 className="py-5  text-xl">Technologies</h2>
          <div className="flex gap-6 flex-wrap">
            <Technologies technologies={technologies} />
          </div>

          <hr className="my-10"></hr>
          <a
            href="https://github.com/eddiemg10/Family-Feud-Discord-bot"
            target="_blank"
            className=" text-cool-300 hover:cursor-pointer flex gap-5"
          >
            <BsGithub size={30} />
            <p className="flex items-center">
              <span>Github repository</span> <FiExternalLink className="ml-2" />{" "}
            </p>
          </a>

          <a
            href="https://discordfeud.web.app/"
            target="_blank"
            className=" mt-5 text-cool-300 hover:cursor-pointer flex gap-5"
          >
            <AiOutlineLink size={30} />
            <p className="flex items-center">
              <span>Go to website</span> <FiExternalLink className="ml-2" />{" "}
            </p>
          </a>
        </div>
        <div className="mt-20 w-full flex flex-col  items-center justify-center">
          <div className="md:w-[90%] w-full">
            <FullCarousel images={images} />
          </div>
        </div>

        <div className="font-thin text-cool-400 lg:text-xl md:text-lg text-base lg:px-20 md:px-10 px-5 mt-20">
          <p className="my-5">
            Discord Feud is a bot that lets you play the game show 'family feud'
            using one command on discord. It is developed using Discord JS, a
            Javascript library that utilizes the Discord API and hosted on
            heroku making it publically available. The website for the bot was
            developed with ReactJS.
          </p>
        </div>

        <div className="mt-20 w-full">
          <h1 className="font-semibold text-4xl text-cool-400 text-center">
            System Demo
          </h1>

          <div className="w-full  mt-20">
            <Demo demos={demos} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiscordFeud;
